(function () {
  Flint.file("views/hamburgerMenu.js", function (require) {
    Flint.staticStyles("HamburgerMenu", {
      "$overlay": "#_flintapp overlay.HamburgerMenu, #_flintapp .HamburgerMenu.overlay, #_flintapp .ViewHamburgerMenu.overlay, #_flintapp .HamburgerMenu > .overlay",
      "$childrenSec": "#_flintapp childrenSec.HamburgerMenu, #_flintapp .HamburgerMenu.childrenSec, #_flintapp .ViewHamburgerMenu.childrenSec, #_flintapp .HamburgerMenu > .childrenSec",
      "$ham": "#_flintapp ham.HamburgerMenu, #_flintapp .HamburgerMenu.ham, #_flintapp .ViewHamburgerMenu.ham, #_flintapp .HamburgerMenu > .ham",
      "$hamWrapper": "#_flintapp hamWrapper.HamburgerMenu, #_flintapp .HamburgerMenu.hamWrapper, #_flintapp .ViewHamburgerMenu.hamWrapper, #_flintapp .HamburgerMenu > .hamWrapper",
      "$shadowSec": "#_flintapp shadowSec.HamburgerMenu, #_flintapp .HamburgerMenu.shadowSec, #_flintapp .ViewHamburgerMenu.shadowSec, #_flintapp .HamburgerMenu > .shadowSec",
      "$expandedHam": "#_flintapp expandedHam.HamburgerMenu, #_flintapp .HamburgerMenu.expandedHam, #_flintapp .ViewHamburgerMenu.expandedHam, #_flintapp .HamburgerMenu > .expandedHam"
    }, {
      "$overlay": {
        position: 'fixed',
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.75)'
      },
      "$childrenSec": {
        flexShrink: 0
      },
      "$ham": {
        height: 34,
        width: 34,
        margin: 8,
        cursor: 'pointer'
      },
      "$hamWrapper": {
        paddingRight: 20,

        width: 2000,
        overflow: 'auto'
      },
      "$shadowSec": {
        background: 'linear-gradient(to right, rgba(50, 50, 50, 0.8) 0%, rgba(0, 0, 0, 0) 100%)',
        position: 'absolute',
        zIndex: 2,
        top: 0,
        right: -20,
        bottom: 0,
        width: 20
      },
      "$expandedHam": {
        position: 'fixed',
        height: '100%',
        zIndex: 100
      }
    });
    Flint.view("HamburgerMenu", function (view, on, $) {
      var context = initContext(view, {
        height: atom(),
        width: atom()
      });

      var pro = initPro(view, {
        children: atom()
      });

      var expanded = atom(false);
      expanded.react(function (expanded) {
        if (expanded) {
          M.mixpanel.track("HamburgerMenuOpen");
        } else {
          M.mixpanel.track("HamburgerMenuClose");
        }
      }, { skipFirst: true });

      var hamWrapperHeight = derivation(function () {
        return context.viewportHeight.get() - 50;
      });

      var onTouchMove = function onTouchMove(e) {
        // Prevent awkwardly scrolling the whole body while
        // menu is open
        e.preventDefault();
      };

      expanded.react(function (expanded) {
        if (expanded) {
          document.body.style.overflow = 'hidden';
          document.body.addEventListener('touchmove', onTouchMove);
          document.body.scrollTop = 0;
        } else {
          document.body.style.overflow = null;
          document.body.removeEventListener('touchmove', onTouchMove);
        }
      }, { skipFirst: true });

      on.unmount(function () {
        document.body.style.overflow = null;
        document.body.removeEventListener('touchmove', onTouchMove);
      });view.render(function () {
        return view.el(["img", 1], { className: "ham", src: "/images/hamburger.png",
          onClick: function () {
            return expanded.set(!expanded.get());
          }
        });
      });view.render(function () {
        return view.el(
          ["FadeTransitioner", 1],
          {
            selectedIndex: expanded.get() ? 0 : -1,
            preloadChildren: false
          },
          view.el(["overlay", 1], null)
        );
      });view.render(function () {
        return view.el(
          ["SlideTransitioner", 1],
          { className: "expandedHam",
            selectedIndex: expanded.get() ? 0 : -1,
            width: 250
          },
          view.el(
            ["hamWrapper", 1],
            {
              ref: function (elem) {
                if (elem) {
                  elem.addEventListener('touchmove', function (e) {
                    // We apparently don't get proper bubbling if we
                    // mix the document.body.addEventListener call with
                    // React's onTouchMove virtual event handler, so
                    // we're using elem.addEventListener.
                    e.stopPropagation();
                  });
                }
              },
              onClick: function () {
                return expanded.set(false);
              }
            },
            view.el(
              ["childrenSec", 1],
              { onClick: function (e) {
                  return e.stopPropagation();
                } },
              pro.children.get()
            ),
            view.el(["shadowSec", 1], null)
          )
        );
      });

      "b2024ba4";
      "006d1a4e";
      "fd09ee1c";

      $["ham"] = function (_, _index) {
        return { opacity: expanded.get() ? 0.2 : 0.7
        };
      };

      "fb8bf918";

      $["hamWrapper"] = function (_, _index) {
        return { height: hamWrapperHeight.get() };
      };

      "08bf1e61";
      "ec181500";
    });
  })
})();
//# sourceMappingURL=hamburgerMenu.js.map
